import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { mockCountryCodes } from '@panel/core/src/mockData';
import { select } from '../../../core/themev2';
import SimpleTooltip from '../../Tooltip/SimpleTooltip';
import DropDown from '../../DropDown/SimpleDropDown';
import ErrorIcon from '../../../assets/icons/check-circle-error.svg';
import IconHelp from '../../../assets/icons/icon-help-gray.svg';
import { InputFormContainer, InputContainer, Input, Option, LabelContainer, ValidIcon } from './styles';

const InputForm = ({
  inputPhoneId,
  device = '',
  type = 'tel',
  number = '',
  phonePrefix = '',
  phoneType = '',
  isPhoneValid = true,
  handleOnChange = () => {},
  handleSetPhoneCode = () => {},
  setDropdownOpen = () => {},
  dropdownOpen = false,
  disabled = false,
  editedValue = false,
  getValidBorder = '',
  emptyInputError = false,
  getTooltipText = null,
  publisherTypeId = '2',
  withLabelTooltip = false,
  withoutPhoneCode = false,
  isLoading = true
}) => {
  const { t } = useTranslation();
  const countryCodesAsArray = Object.values(mockCountryCodes);
  const showMessaggeError = !isPhoneValid && !editedValue && !disabled && !isLoading;
  const validBorder = !isLoading && getValidBorder;

  return (
    <InputFormContainer>
      <LabelContainer>
        <label htmlFor={inputPhoneId} data-panel={`panel-form-label-${inputPhoneId}`}>
          {t(`panel.contactValidation.modal.form.${inputPhoneId}`, { publisherTypeId: [publisherTypeId] })}
        </label>
        {withLabelTooltip && (
          <SimpleTooltip
            offset={10}
            backgroundColor={select('white')}
            textColor={select('black')}
            borderColor={select('neutralDarkGray')}
            sizeArrow={8}
            isMobile={false}
            text={getTooltipText}
            dataPanel='panel-contactValidation-tooltip-branch'
            data-panel={`form-label-tooltip-${inputPhoneId}`}
            position={`${device !== 'desktop' ? 'top' : 'right'}-center`}
            allowPlacements='top-end'
            autoPlacements
            alignChildren
          >
            <img src={IconHelp} alt='icon-help' data-panel={`form-label-iconTooltip-${inputPhoneId}`} />
          </SimpleTooltip>
        )}
      </LabelContainer>
      <InputContainer>
        {!withoutPhoneCode && (
          <DropDown
            dropdownOpen={dropdownOpen}
            setDropdownOpen={setDropdownOpen}
            textHeader={phonePrefix || ''}
            borderColor='black'
            width='80px'
            height='48px'
            marginTop='0px'
            marginLeft='12px'
            chevronHeight='16px'
          >
            {countryCodesAsArray &&
              countryCodesAsArray.map(phoneCodeItem => (
                <Option
                  key={phoneCodeItem.country}
                  data-panel={`dropDownOption-phoneCode-${inputPhoneId}-${phoneCodeItem.country}`}
                  onClick={() => handleSetPhoneCode(inputPhoneId, phoneCodeItem.value)}
                >
                  {phoneCodeItem.label}
                </Option>
              ))}
          </DropDown>
        )}
        <div className='numberInput'>
          <Input
            data-panel={`panel-form-phone-${inputPhoneId}`}
            type={type}
            id={inputPhoneId}
            name={phoneType}
            placeholder={t('panel.contactValidation.modal.form.phone.placeholder')}
            value={number || ''}
            onChange={handleOnChange}
            validBorder={validBorder}
            disabled={disabled}
            onKeyDown={e => (e.key === 'Enter' ? e.preventDefault() : null)}
            autoComplete='off'
          />
          {showMessaggeError && (
            <ValidIcon
              src={ErrorIcon}
              alt={`iconValid-phone-${inputPhoneId}`}
              data-panel={`panel-form-phone-icon-${inputPhoneId}`}
            />
          )}
          {showMessaggeError && (
            <span data-panel={`panel-form-phone-error-${inputPhoneId}`} className='errorMessage'>
              {t('panel.contactValidation.modal.form.formatError')}
            </span>
          )}
          {emptyInputError && !disabled && (
            <span data-panel={`panel-form-phone-emptyError-${inputPhoneId}`} className='errorMessage'>
              {t('panel.contactValidation.modal.form.emptyInputError')}
            </span>
          )}
        </div>
      </InputContainer>
    </InputFormContainer>
  );
};

InputForm.propTypes = {
  inputPhoneId: PropTypes.string.isRequired
};

export { InputForm };
